import styled from '@emotion/styled'
import type { CountryContext } from 'react-svg-worldmap'
import { Grid, Icon, Theme } from '@yuno/design-system-web'
import WorldMap from 'react-svg-worldmap'
import ReactCountryFlag from 'react-country-flag'
import { countryNames } from '../../utils/constants'
import { useEffect, useLayoutEffect, useState } from 'react'
import useWindowDimensions from '../../hooks/window-dimensions.hook'
import { ConnectionCardError } from '../connection-card-error'

type StyledProps = { theme?: Theme }

type ConnectionMapProps = { location_coverage: Array<string> }

const CountryListContainer = styled(Grid)<{ windowWidth: number }>`
  width: 221px;
  max-height: ${(props) => (props.windowWidth < 1610 ? '410px' : '521px')};
  margin-left: 20px;
  margin-bottom: 20px;
  overflow-y: auto;
`

const CountryNameContainer = styled('div')<StyledProps>`
  width: 361px;
  width: fit-content;
  padding: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const CountryName = styled('p')<StyledProps>`
  font-size: ${({ theme }) => theme.typography.tiny.regular.fontSize};
  font-weight: ${({ theme }) => theme.typography.tiny.regular.fontWeight};
  font-family: ${({ theme }) => theme.typography.tiny.regular.fontFamily};
  margin-left: 10px;
`

const VerticalLine = styled('div')<StyledProps>`
  min-height: 100%;
  width: 0px;
  margin-top: -10px;
  border: 1px solid ${({ theme }) => theme.palette.grey[2]};
`

const CountryFlag = styled(ReactCountryFlag)`
  height: 16px;
  width: 22px;
`
const showAllCountriesValue = 'ALL_WORLD'
const getLocalizedText = ({ countryName }: CountryContext) => `${countryName}`

const CountryList = ({ countries }: { countries: Array<any> }): JSX.Element => {
  return (
    <>
      {countries?.map((country, index) => {
        return (
          <CountryNameContainer key={index}>
            <CountryFlag className="emojiFlag" countryCode={country} />
            <CountryName>{countryNames[country]}</CountryName>
          </CountryNameContainer>
        )
      })}
    </>
  )
}

export const ConnectionMap = ({ location_coverage }: ConnectionMapProps) => {
  const [worlMapData, setWorlMapData] = useState([])
  const [countries, setCountries] = useState([])
  const { width: windowWidth } = useWindowDimensions()

  useEffect(() => {
    if (location_coverage?.length) {
      const showAllCountries =
        location_coverage?.filter(
          (country) => country === showAllCountriesValue,
        ).length > 0

      const countries = showAllCountries
        ? Object.keys(countryNames)
        : location_coverage
      const sortCountries = countries.sort();
      setCountries(sortCountries)
      setWorlMapData(
        countries.map((location) => {
          return { country: location, value: 1 }
        }),
      )
    }
  }, [location_coverage])

  return (
    <Grid container style={{ height: '100%' }}>
      {countries?.length ? (
        <>
          <CountryListContainer item windowWidth={windowWidth}>
            <CountryList countries={countries} />
          </CountryListContainer>
          <VerticalLine />
          <Grid item>
            <WorldMap
              color="#6400FF"
              size={
                windowWidth < 1120 ? 'md' : windowWidth < 1610 ? 'lg' : 'xl'
              }
              data={worlMapData}
              tooltipTextFunction={getLocalizedText}
            />
          </Grid>
        </>
      ) : (
        <ConnectionCardError />
      )}
    </Grid>
  )
}
